var _Checkbox;
import React from 'react';
import { times } from 'lodash';
import { useIntl } from '@lumahealthhq/ui-components';
import { Box, Checkbox, FormControlLabel, Skeleton, Stack, TextFieldSearch } from '@lumahealthhq/ui-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FilterFieldContentLoad() {
  var intl = useIntl();
  return /*#__PURE__*/_jsxs(Box, {
    sx: function sx(theme) {
      return {
        display: 'flex',
        py: 2,
        px: 1,
        flexDirection: 'column',
        gap: theme.spacing(3)
      };
    },
    children: [/*#__PURE__*/_jsxs(Stack, {
      direction: "row",
      alignItems: "center",
      px: 1,
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(FormControlLabel, {
        label: intl.formatMessage({
          id: "94Fg25",
          defaultMessage: [{
            "type": 0,
            "value": "Select all"
          }]
        }),
        control: _Checkbox || (_Checkbox = /*#__PURE__*/_jsx(Checkbox, {
          disabled: true
        }))
      }), /*#__PURE__*/_jsx(TextFieldSearch, {
        disabled: true,
        onChange: function onChange() {
          return null;
        }
      })]
    }), /*#__PURE__*/_jsx(Stack, {
      flexWrap: "wrap",
      direction: "row",
      gap: 1,
      pb: 4,
      sx: {
        position: 'relative',
        maxHeight: '120px',
        minHeight: '90px',
        overflow: 'auto'
      },
      children: times(7).map(function (index) {
        return /*#__PURE__*/_jsx(Skeleton, {
          variant: "rounded",
          width: 120,
          height: 32
        }, "chip_loader_".concat(index));
      })
    })]
  });
}